import { AssetStatus } from "@hydrologiq/gql-experience/graphql"

/**
 * Returns a text color for the given lifecycle status.
 *
 * Four-tier visual hierarchy:
 *  1. Red — problem (Error)
 *  2. Amber — transitional/attention (Startup, Testing)
 *  3. Black — operational (Active, Deployed, Standby)
 *  4. Grey — logistics/idle (Available, Reserved, Filling, etc.)
 */
export function getStatusColor(status: AssetStatus | null | undefined): string {
  switch (status) {
    // Tier 1: Error → red
    case AssetStatus.Error:
      return "red"

    // Tier 2: Transitional → amber
    case AssetStatus.Startup:
    case AssetStatus.Testing:
      return "#d97706"

    // Tier 3: Operational → default text (black in light mode)
    case AssetStatus.Active:
    case AssetStatus.Deployed:
    case AssetStatus.Standby:
      return "fg"

    // Tier 4: Logistics/idle → grey
    case AssetStatus.Available:
    case AssetStatus.Unreserved:
    case AssetStatus.Reserved:
    case AssetStatus.Servicing:
    case AssetStatus.Filling:
    case AssetStatus.DispatchReady:
    case AssetStatus.Outbound:
    case AssetStatus.Inbound:
    case AssetStatus.DepotChecked:
      return "grey"

    // Unknown / null / undefined
    case AssetStatus.Unknown:
    case null:
    case undefined:
    default:
      return "grey"
  }
}
